<template>
  <div>
    <sidenav
      :is-sidebar-active.sync="isSidebarActive"
      :item-edit.sync="itemEdit"
      :is-add.sync="isAdd"
      @refetch-data="refetchData"
      :watchlist-options="watchlistOptions"
    />

    <b-row class="pt-2 pb-1">
      <b-col cols="6">
        <BreadcrumbMenu />
      </b-col>
      <b-col cols="6" class="pr-3 text-right">
        <div class="d-inline-flex align-items-center">
        </div>
      </b-col>
    </b-row>

    <toastification-loading-content ref="loadingToast"/>

    <!-- Table Container Card -->
    <b-card class="m-2" no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label class="text-capitalize">{{ $t("table.show") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label class="text-capitalize mr-1">{{ $t("table.entries") }}</label>
            <btn-refresh-table
              :fetch-list="refetchData"
            />
          </b-col>

          <!-- Search -->
          <b-col cols="11" md="5">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                :placeholder="$t('table.search')"
              />
              <b-button
                variant="primary"
                @click="openAdd()"
                v-if="$can('create', 'NtechlabCamera')"
              >
                <span class="text-nowrap text-capitalize">
                  {{ `${$t("actions.add")} ${$t("ntechlab.camera.title")}` }}
                </span>
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" md="1">
            <b-button
              @click="exportExcel()"
              variant="success"
              class="text-capitalize"
              type="button"
              :disabled="buttonExport"
            >
              <feather-icon icon="DownloadCloudIcon" size="15"/>
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('no_record_found')"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #head()="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <template #head(actions)="data">
          <span> {{ $tc(data.label, 2) }}</span>
        </template>

        <!-- status -->
        <template #cell(status)="data">
          <b-media vertical-align="center">
            <template #aside>
              <div
                :style="`background: ${data.item.status === 'STARTING' ? 'orange' : data.item.status !== 'NOT_STARTED' ? 'green' : 'red'};
                        width: 1.5rem;
                        height: 1.5rem;
                        border-radius: 1rem;
                        text-align: center;`"
              ></div>
            </template>
            <span class="text-capitalize">{{ data.item.status }}</span>
          </b-media>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              @click="reloadStream(data.item.id)"
            >
                <feather-icon icon="RefreshCwIcon" />
                <span class="align-middle ml-50 text-capitalize"
                  >{{ $t("ntechlab.camera.refresh") }}
                </span>
              </b-dropdown-item>

            <b-dropdown-item
              @click="confirmDelete(data.item.id)"
              v-if="$can('delete', 'NtechlabCamera')"
            >
              <feather-icon icon="TrashIcon"/>
              <span class="align-middle ml-50 text-capitalize">{{
                  $t("actions.delete")
                }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted text-capitalize">{{
                $t("table.showing", {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <Pagination
              :totalList="totalList"
              :currentPage="currentPage"
              @updatePagination="update"
              :perPage="perPage"
            >
            </Pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BButton,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import Vue from "vue";
import vSelect from "vue-select";
import {ref, computed, watch} from "@vue/composition-api";
import useList from "./useList";
import Sidenav from "./Sidenav.vue";
import {useToast} from "vue-toastification/composition";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import {useUtils as useI18nUtils} from "@core/libs/i18n";
import BreadcrumbMenu from "@/components/BreadcrumbMenu.vue";
import ToastificationLoadingContent
  from "@core/components/toastification/ToastificationLoadingContent.vue";
import Pagination from "@/components/Pagination.vue";
import BtnRefreshTable from "@/components/Btn Refresh Table/index.vue";

export default {
  components: {
    Sidenav,
    BreadcrumbMenu,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ToastificationLoadingContent,
    Pagination,
    BtnRefreshTable,
  },

  setup(_, context) {
    //start pagination
    const update = (data) => {
      currentPage.value = data;
    };
    //end pagination

    const buttonExport = ref(false);
    const loadingToast = ref(null);
    const action = ref("list");


    const exportExcel = () => {
      action.value == "export";
      buttonExport.value = true;
      loadingToast.value.show(
        context.parent.$i18n.t("messages.export.download"),
        context.parent.$i18n.t("messages.export.Generating_file"),
        "secondary"
      );
      store
        .dispatch("ntechlab_camera/export", {
          q: searchQuery.value,
          max: perPage.value,
          "page[n]": currentPage.value,
          sortBy: sortBy.value,
          sortDesc: isSortDirDesc.value,
          action: "export",
        })
        .then((response) => {
          console.log(response);
        })
        .catch(() => {
          toast({
            component: ToastificationContent,
            props: {
              title: context.parent.$i18n.t("messages.error.server_error"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          loadingToast.value.close();
          buttonExport.value = false;
        });
    };
    const notifications = computed(() => store.getters["grid/getAlarms"]);

    const isSidebarActive = ref(false);
    const itemEdit = ref({});
    const isAdd = ref(false);
    const openEdit = (item) => {
      isSidebarActive.value = true;
      itemEdit.value = item;
      isAdd.value = false;
    };
    const {t} = useI18nUtils();
    const toast = useToast();
    const {
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      watchlistOptions,
    } = useList();

    const confirmDelete = function (id) {
      const self = this;
      const storeInner = store;
      this.$swal({
        title: context.parent.$i18n.t("messages.delete.title"),
        text: context.parent.$i18n.t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: context.parent.$i18n.t("actions.delete"),
        cancelButtonText: context.parent.$i18n.t("actions.cancel"),
        customClass: {
          confirmButton: "btn btn-primary text-capitalize",
          cancelButton: "btn btn-outline-danger ml-1 text-capitalize",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeInner
            .dispatch("ntechlab_camera/delete", id)
            .then((response) => {
              if (response.success) {
                toast({
                  component: ToastificationContent,
                  props: {
                    title: response.message,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                self.refetchData();
              } else {
                toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: response.message,
                      icon: "AlertTriangleIcon",
                      variant: "danger",
                    },
                  },
                  {
                    timeout: 10000,
                  }
                );
              }
            })
            .catch((response) => {
              toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: response.response.data.message,
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                  },
                },
                {
                  timeout: 10000,
                }
              );
            });
        }
      });
    };

    const openAdd = () => {
      isAdd.value = true;
      isSidebarActive.value = true;
    };

    const reloadStream = (id) => {
      store
      .dispatch("ntechlab_camera/reloadStream", id)
      .then((response) => {
        if (response.success) {
          toast({
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "CheckIcon",
              variant: "success",
            },
          });
          self.refetchData();
        } else {
          toast(
            {
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            },
            {
              timeout: 10000,
            }
          );
        }
      })
      .catch((response) => {
        toast(
          {
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          },
          {
            timeout: 10000,
          }
        );
      });
    }

    const getCameraStatus = async (item) => {
      try {
        const id_master_account = item.id_master_account;
        const data = {
          camera_id: item.id_ntechlab_camera,
          id_master_account: id_master_account
        }
        const response = await store.dispatch("ntechlab_camera/getStatus", data);
        if (response.success) {
          Vue.set(item, "status", response.data.status);
        }
      } catch (error) {
        console.error('Error getting camera status:', error);
      }
    };

    // Add a watcher for the table's localItems
    watch(() => refListTable.value?.localItems, (newItems) => {
      if (newItems && newItems.length > 0) {
        newItems.forEach(item => {
          getCameraStatus(item);
        });
      }
    }, { immediate: true });

    return {
      isSidebarActive,
      isAdd,
      itemEdit,
      openEdit,
      openAdd,
      confirmDelete,
      notifications,
      buttonExport,
      loadingToast,
      action,
      exportExcel,
      fetchList,
      tableColumns,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,
      formatDateAssigned,
      update,
      reloadStream,
      watchlistOptions,
      getCameraStatus
    };
  },
};
</script>
